export const DELETE_CHART_REQUEST = " DELETE_CHART_REQUEST";
export const DELETE_CHART_SUCCESS = " DELETE_CHART_SUCCESS";
export const DELETE_CHART_FAILURE = " DELETE_CHART_FAILURE";
